import { t } from "i18next";
import {
  ExerciseDONE,
  CorrectionItem,
  LoginUserResponse,
  CorrectionBookItem,
} from "@/types";
import NoItem from "@/components/NoItem.tsx";
import ExerciseItem from "@/components/exercises/ExerciseItem.tsx";

interface DoneListProps {
  me: undefined | LoginUserResponse;
  done: number;
  total: number;
  exercises: ExerciseDONE[];
  countCorrections: CorrectionItem[];
  countBookedCorrections: CorrectionBookItem[];
}

const DoneList = ({ me, exercises }: DoneListProps) => {
  if (!exercises?.length) {
    return (
      <NoItem
        text={t("home.course.no_exercise_msg", {
          defaultValue: "Exercises not available",
        })}
      />
    );
  }

  const canBookWritings =
    exercises.filter(
      (el: ExerciseDONE) =>
        el?.corrected == null &&
        el?.type?.toLowerCase() == "writing" &&
        me?.hasWritingCorrection,
    ).length > 1;

  return exercises.map((exercise, i) => (
    <ExerciseItem
      key={i + "" + exercise.id}
      status="done"
      exercise={exercise}
      canBookWritings={canBookWritings}
    />
  ));
};

export default DoneList;
